import React from "react";
import { Grid } from "@mui/material";

import formatDate from "utils/formatDate";
import { DEFAULT_DATE_FORMAT } from "static/date";
import GridListItem from "components/common/grid/GridListItem";

const GuarantorInformationItem = ({ guarantor }) => {
  return (
    <Grid container columnSpacing={3}>
      <Grid item container columnSpacing={3} className="view-pdf__drawer-grid">
        <GridListItem title="MRN" subTitle={guarantor?.mrn ?? "—"} size="3" />
        <GridListItem
          title="FIRST NAME"
          subTitle={guarantor?.first_name ?? "—"}
          size="3"
        />
        <GridListItem
          title="MI"
          subTitle={guarantor?.middle_name ?? "—"}
          size="3"
        />
        <GridListItem
          title="LAST NAME"
          subTitle={guarantor?.last_name ?? "—"}
          size="3"
        />
        <GridListItem
          title="Date of Birth"
          subTitle={formatDate(guarantor?.dob, DEFAULT_DATE_FORMAT) ?? "—"}
          size="3"
        />
        <GridListItem
          title="GENDER"
          subTitle={guarantor?.gender ?? "—"}
          size="3"
        />
        <GridListItem
          title="PATIENT RELATION"
          subTitle={guarantor?.patient_relation ?? "—"}
          size="3"
        />
        <GridListItem
          title="GUARANTOR TYPE"
          subTitle={guarantor?.type ?? "—"}
          size="3"
        />
        <Grid
          container
          columnSpacing={3}
          className="view-pdf__drawer-grid"
        ></Grid>
        <GridListItem
          title="PHONE 1"
          subTitle={guarantor?.phone1 ?? "—"}
          size="3"
        />
        <GridListItem
          title="PHONE 2"
          subTitle={guarantor?.phone2 ?? "—"}
          size="3"
        />
        <GridListItem
          title="EMAIL"
          subTitle={guarantor?.email ?? "—"}
          size="3"
        />
        <Grid
          container
          columnSpacing={3}
          className="view-pdf__drawer-grid"
        ></Grid>
        <GridListItem
          title="STREET ADDRESS"
          subTitle={guarantor?.street ?? "—"}
          size="3"
        />
        <GridListItem title="CITY" subTitle={guarantor?.city ?? "—"} size="3" />
        <GridListItem
          title="STATE"
          subTitle={guarantor?.state ?? "—"}
          size="3"
        />
        <GridListItem title="ZIP" subTitle={guarantor?.zip ?? "—"} size="3" />
      </Grid>
    </Grid>
  );
};

export default GuarantorInformationItem;
